// extracted by mini-css-extract-plugin
export default {"root":"styles_root__wT1g+","label":"styles_label__dV2OU","left":"styles_left__Ix670","right":"styles_right__aF-ZU","box":"styles_box__yUBlz"};